// Total reviews service - tracks all submitted reviews
import { db } from '../firebase';
import { doc, getDoc, setDoc, increment } from 'firebase/firestore';

const TOTAL_REVIEWS_DOC_ID = 'total_reviews';
const STATS_COLLECTION = 'site_stats';

// Get current total reviews from Firestore
export const getTotalReviews = async () => {
  try {
    const docRef = doc(db, STATS_COLLECTION, TOTAL_REVIEWS_DOC_ID);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      return docSnap.data().count || 0;
    } else {
      // Initialize with 0 if document doesn't exist
      await setDoc(docRef, { count: 0, lastUpdated: new Date() });
      return 0;
    }
  } catch (error) {
    console.error('Error getting total reviews:', error);
    return 0;
  }
};

// Increment total reviews count
export const incrementTotalReviews = async () => {
  try {
    const docRef = doc(db, STATS_COLLECTION, TOTAL_REVIEWS_DOC_ID);
    await setDoc(docRef, {
      count: increment(1),
      lastUpdated: new Date(),
    }, { merge: true });

    // Return the new count
    return await getTotalReviews();
  } catch (error) {
    console.error('Error incrementing total reviews:', error);
    return 0;
  }
};

// Set total reviews count (for admin purposes)
export const setTotalReviewsCount = async (count) => {
  try {
    const docRef = doc(db, STATS_COLLECTION, TOTAL_REVIEWS_DOC_ID);
    await setDoc(docRef, {
      count: count,
      lastUpdated: new Date(),
    });
    return true;
  } catch (error) {
    console.error('Error setting total reviews count:', error);
    return false;
  }
};
